import styled from '@emotion/styled';

export const Hint = styled.li`
  font-family: var(--font-work-sans, 'Work Sans');
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`;
